module.exports = __webpack_public_path__ + "img/91904.930af2f0.svg";